import cn from 'classnames';
import {Dispatch, SetStateAction} from 'react';
import Modal from '../../../components/mazraeKit/modal';
import SpinnerLoading from '../../../components/SpinnerLoading';
import useDeleteBasket from '../../../services/hookService/deleteBasket/useDeleteBasket';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  basket_guid: string;
}

const RemoveFromBasketModal = ({isOpen, setIsOpen, basket_guid}: IProps) => {
  const handleAfterDelete = () => {
    setIsOpen(false);
  };

  const {mutate, isLoading} = useDeleteBasket(handleAfterDelete);

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="relative w-[320px] rounded-xl">
        {/* Spinner Overlay */}
        {isLoading && (
          <div className="absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white/40 backdrop-blur-sm">
            <SpinnerLoading size={35} />
          </div>
        )}

        {/* Modal Content */}
        <div
          className={cn(
            'flex flex-col p-4 gap-3 transition-all',
            isLoading && ' blur-sm pointer-events-none',
          )}
        >
          {/* Close */}
          <button
            onClick={() => setIsOpen(false)}
            className="absolute left-5 top-5"
          >
            <i className="text-2xl text-gray-700 icon-nameClose-remove" />
          </button>

          {/* Icon + Title */}
          <div className="flex flex-col items-center justify-center gap-2">
            <i className="text-5xl text-red-500 icon-warning-triangle" />
            <h5 className="text-lg text-gray-950">حذف مورد</h5>
          </div>

          {/* Text */}
          <p className="text-center text-gray-700 text-md font-Regular">
            از حذف این مورد مطمئن‌اید؟
          </p>

          {/* Actions */}
          <div className="flex items-center gap-2">
            <button
              className="w-full h-10 text-sm bg-transparent border rounded-lg text-farm-shop-500 border-farm-shop-500"
              onClick={() => setIsOpen(false)}
            >
              انصراف
            </button>

            <button
              className="w-full h-10 text-sm text-white bg-red-500 rounded-lg"
              onClick={() => mutate(basket_guid)}
            >
              حذف
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveFromBasketModal;
